import { Options } from "vue-class-component";

import config from "@/config/config";
import PageBaseView from "@/pages/PageBaseView";
import { Newsletter } from "@/domain/newsletter.model";

@Options({
  name: "newsletter-view",
  props: {
    id: String,
  },
})
export default class NewsletterView extends PageBaseView {
  public row: Newsletter = {
    description: "",
    enabled: false,
  };

  public mounted(): void {
    this.url = "newsletter";
    this.module = config.modules.newsletter;

    this.$store
      .dispatch("newsletter/get", this.id)
      .then((res: Newsletter) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = "Registro não encontrado.";
        }
      })
      .catch(() => {
        this.errorMessage = "Registro não encontrado.";
      });
  }
}
